import { useTranslation } from 'react-i18next'
import { Modal } from '../../components/Modal.js'

/** `separator` se pinta como texto plano entre teclas; sin él, las teclas son una secuencia (p.ej. `g` luego `m`). */
const SHORTCUTS = [
  { keys: ['c'], labelKey: 'shortcuts.create' },
  { keys: ['/'], labelKey: 'shortcuts.search' },
  { keys: ['Esc'], labelKey: 'shortcuts.close' },
  { keys: ['1', '2', '3'], separator: '/', labelKey: 'shortcuts.move' },
  { keys: ['g', 'm'], labelKey: 'shortcuts.goHome' },
  { keys: ['?'], labelKey: 'shortcuts.help' },
] as const

/** Modal de ayuda con `?` (CLAUDE.md §6). */
export function HelpModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation()

  return (
    <Modal titleId="help-modal-title" onClose={onClose}>
      <div className="flex flex-col gap-4">
        <h2 id="help-modal-title" className="text-title font-semibold text-text">
          {t('shortcuts.title')}
        </h2>
        <dl className="flex flex-col gap-2">
          {SHORTCUTS.map((shortcut) => (
            <div key={shortcut.labelKey} className="flex items-center justify-between gap-4">
              <dt className="text-body text-text-muted">{t(shortcut.labelKey)}</dt>
              <dd className="flex items-center gap-1">
                {shortcut.keys.map((key, index) => (
                  <span key={key} className="flex items-center gap-1">
                    {index > 0 && 'separator' in shortcut && (
                      <span className="text-meta text-text-muted">{shortcut.separator}</span>
                    )}
                    <kbd className="rounded-card border border-border bg-surface-hi px-2 py-0.5 font-mono text-meta text-text">
                      {key}
                    </kbd>
                  </span>
                ))}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </Modal>
  )
}
